import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import facebook from "../assets/facebook.png";
// import instagram from "../assets/instagram.png";
// import linkedin from "../assets/youtube.png";
// import twitter from "../assets/twitter.png";
import wlogo from "../assets/wflogo.png";
import AppointmentModal from "../components/AppointmentModal";

function Footer() {
  const [openModal, setOpenModal] = React.useState(false);
  return (
    <footer className="footer">
      {/* CTA FULL WIDTH TEXT + BUTTONS */}
      <section className="cta-full">
        <div className="cta-full-text">
          <h2>Worried about your vision?</h2>
          <p>
            Book a consultation today and let our team guide you with a simple,
            clear treatment plan.
          </p>
        </div>

        <div className="cta-actions-top">
          <Link
            to="/services"
            className="btn primary-btn"
            onClick={() => setOpenModal(true)}
          >
            Book Appointment
          </Link>
          <a href="tel:+916000678383" className="btn ghost-btn">
            Call Reception
          </a>
        </div>
      </section>

      {/* MAIN FOOTER GRID */}
      <div className="footer-content">
        {/* LEFT */}
        <div className="footer-left">
          <img src={wlogo} alt="Hospital Logo" className="footer-logo" />
          <h4>Connect With Us</h4>

          <div className="social-icons">
            <a href="https://www.facebook.com/people/Oculus-Eye-Hospital/61585282201119/" target="_blank" rel="noopener noreferrer">
              <img src={facebook} alt="Facebook" />
            </a>
            {/* <a href="#">
              <img src={instagram} alt="Instagram" />
            </a>
            <a href="#">
              <img src={linkedin} alt="LinkedIn" />
            </a>
            <a href="#">
              <img src={twitter} alt="Twitter" />
            </a> */}
          </div>
        </div>

        {/* MAP */}
        <div className="footer-map">
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps?q=26.34862,92.67289&z=16&output=embed"
              loading="lazy"
              style={{ border: 0, borderRadius: "16px" }}
            ></iframe>

            <a
              className="map-click-layer"
              href="https://maps.app.goo.gl/URVtYew84HYrvuQV7"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="footer-right">
          <div className="footer-company">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <AppointmentModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Oculus Eye Hospital | All Rights Reserved
          | Developed by{" "}
          <a
            href="https://forms.gle/nSJUnqmRUpT6tGBc8"
            target="_blank"
            rel="noopener noreferrer"
            className="bitcrackerz-link"
          >
            <strong>BitCrackerz</strong>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
